import { Column } from "@silevis/reactgrid";
import { useEffect, useRef, useState } from "react";
import { TooltipStyles } from "../style";

interface IProps {
  columns: Column[];
}

const TooltipHeader = (props: IProps) => {
  const [scrollLeft, setScrollLeft] = useState(0);
  const [headerPosition, setHeaderPosition] = useState({ top: 0, left: 0 });
  const [viewportBounds, setViewportBounds] = useState({ left: 0, right: 0 });
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const scrollableElement = document.querySelector(
      ".rg-pane-content",
    ) as HTMLElement;

    const headerElement = document.querySelector(".rg-pane-top") as HTMLElement;

    const handleScroll = () => {
      if (scrollableElement) {
        setScrollLeft(scrollableElement.scrollLeft);
      }
      updatePosition();
    };

    const updatePosition = () => {
      if (headerElement) {
        const rect = headerElement.getBoundingClientRect();
        setHeaderPosition({ top: rect.top, left: rect.left });
      }
      const scrollableContent = document.querySelector(
        ".rg-pane-center .rg-pane-content",
      ) as HTMLElement;

      if (scrollableContent) {
        const rect = scrollableContent.getBoundingClientRect();
        setViewportBounds({
          left: rect.left,
          right: rect.right,
        });
      } else {
        const tableMain = document.querySelector(".table-main") as HTMLElement;
        if (tableMain) {
          const rect = tableMain.getBoundingClientRect();
          setViewportBounds({
            left: rect.left,
            right: rect.right,
          });
        }
      }
    };

    if (scrollableElement) {
      scrollableElement.addEventListener("scroll", handleScroll);
    }

    updatePosition();
    window.addEventListener("resize", updatePosition);
    window.addEventListener("scroll", updatePosition, true);

    const intervalId = setInterval(updatePosition, 100);

    return () => {
      scrollableElement?.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", updatePosition);
      window.removeEventListener("scroll", updatePosition, true);
      clearInterval(intervalId);
    };
  }, []);

  if (!props.columns) return null;

  let cumulativeWidth = 0;

  return (
    <TooltipStyles ref={containerRef}>
      {props.columns.map((col: any) => {
        const columnLeftInTable = cumulativeWidth;
        cumulativeWidth += col.width || 0;
        const displayLeft =
          headerPosition.left + columnLeftInTable - scrollLeft;
        const displayRight = displayLeft + (col.width || 0);
        const visibleWidth =
          Math.min(displayRight, viewportBounds.right) -
          Math.max(displayLeft, viewportBounds.left);
        const visiblePercentage = visibleWidth / (col.width || 1);

        const isVisible = viewportBounds.right > 0 && visiblePercentage >= 0.8;

        if (!col.tooltip) {
          return (
            <div
              key={col.columnId}
              className="tooltip-cell-empty"
              style={{
                width: col.width || 0,
              }}
            />
          );
        }

        return (
          <div
            key={col.columnId}
            className="tooltip-cell"
            style={{
              width: col.width || 0,
            }}
          >
            {isVisible && (
              <div
                className="tooltip-content"
                style={{
                  left: displayLeft + (col.width || 0) / 2,
                  top: headerPosition.top - 3,
                  transform: "translate(-50%, -100%)",
                  maxWidth: col?.maxWidthTooltip,
                }}
              >
                {col.tooltip.split("\n").map((line: string, idx: number) => (
                  <div key={idx}>{line}</div>
                ))}
              </div>
            )}
          </div>
        );
      })}
    </TooltipStyles>
  );
};

export default TooltipHeader;
